import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  APPROVE_EMPLOYEE,
  REJECT_EMPLOYEE,
  GET_ADDEMPLOYEE,
  GET_EMPLOYEEDETAILS,
  GET_EMPLOYEESLIST,
  GET_UPDATEEMPLOYEE,
  UPLOAD_EMPLOYEE_EXCEL,
} from "resources/actionTypes";

import {
  getEmployeesList,
  addEmployeeService,
  getEmployeeDetailsService,
  updateEmployeeService,
  uploadEmployeeExcelService,
  approveEmployeeService,
  rejectEmployeeService,
} from "services/EmployeesService";
import { onLoaderTrigger } from "redux/actions/commonAction";
import store from "redux/store";

function* fetchGetEmployeesList(action) {
  const payload = action.payload || {};
  const employeesList = yield call(getEmployeesList, payload);
  if (employeesList.success) {
    yield put({
      type: GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_SUCCESS,
      employeesList: employeesList,
    });
  } else {
    yield put({
      type: GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_FAILED,
      message: employeesList.message,
    });
    toast.error(employeesList?.message || "Fetch Employee Failed");
  }
}

export function* getEmployeesListWatcher() {
  yield takeEvery(
    GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_REQUESTED,
    fetchGetEmployeesList,
  );
}

// Employee Details

function* fetchEmployeeDetails(action) {
  const payload = action.payload || {};

  const employeesDetails = yield call(getEmployeeDetailsService, payload);

  if (employeesDetails.success) {
    yield put({
      type: GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_SUCCESS,
      employeesDetails: employeesDetails,
    });
  } else {
    yield put({
      type: GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_FAILED,
      message: employeesDetails.message,
    });

    toast.error(employeesDetails.message || "Fetching Employee Details Failed");
  }
}

export function* getEmployeeDetailsWatcher() {
  yield takeEvery(
    GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_REQUESTED,
    fetchEmployeeDetails,
  );
}

// Add Employee

function* fetchAddEmployee(action) {
  store.dispatch(onLoaderTrigger(true));

  const payload = action.payload || {};

  const response = yield call(addEmployeeService, payload.employeeData);

  if (response?.success) {
    yield put({
      type: GET_ADDEMPLOYEE.GET_ADDEMPLOYEE_SUCCESS,
    });

    toast.success(response.message);

    payload.navigate("/employees");
  } else {
    yield put({
      type: GET_ADDEMPLOYEE.GET_ADDEMPLOYEE_FAILED,
      message: response.message,
    });

    toast.error(response.message || "Add Employee Failed");
  }

  store.dispatch(onLoaderTrigger(false));
}

export function* addEmployeeSaga() {
  yield takeEvery(GET_ADDEMPLOYEE.GET_ADDEMPLOYEE_REQUESTED, fetchAddEmployee);
}

// Update Employee

function* fetchUpdateEmployee(action) {
  store.dispatch(onLoaderTrigger(true));

  const payload = action.payload || {};

  const response = yield call(
    updateEmployeeService,
    payload.employeeData,
    payload.employeeId,
  );

  if (response?.success) {
    yield put({
      type: GET_UPDATEEMPLOYEE.GET_UPDATEEMPLOYEE_SUCCESS,
    });

    toast.success(response.message);

    payload.navigate("/employees");
  } else {
    yield put({
      type: GET_UPDATEEMPLOYEE.GET_UPDATEEMPLOYEE_FAILED,
      message: response.message,
    });

    toast.error(response.message || "Update Employee Failed");
  }

  store.dispatch(onLoaderTrigger(false));
}

export function* updateEmployeeSaga() {
  yield takeEvery(
    GET_UPDATEEMPLOYEE.GET_UPDATEEMPLOYEE_REQUESTED,
    fetchUpdateEmployee,
  );
}

// Upload Excel

function* fetchUploadEmployeeExcel(action) {
  store.dispatch(onLoaderTrigger(true));

  try {
    const payload = action.payload || {};

    const response = yield call(uploadEmployeeExcelService, payload);

    if (response?.success) {
      yield put({
        type: UPLOAD_EMPLOYEE_EXCEL.UPLOAD_EMPLOYEE_EXCEL_SUCCESS,
        data: response,
      });

      yield put({
        type: GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_REQUESTED,
        payload: {
          companyId: payload.companyId,
          search: "",
          page: 0,
          pageSize: 10,
          status: "",
        },
      });

      if (response?.data?.failed > 0) {
        toast.warning(
          `${response?.data?.created || 0} employees added, ${response?.data?.failed} failed`,
        );
      } else {
        toast.success(response.message || "Employees uploaded successfully");
      }
    } else {
      yield put({
        type: UPLOAD_EMPLOYEE_EXCEL.UPLOAD_EMPLOYEE_EXCEL_FAILED,
        message: response?.message,
      });

      toast.error(response?.message || "Excel Upload Failed");
    }
  } catch (error) {
    yield put({
      type: UPLOAD_EMPLOYEE_EXCEL.UPLOAD_EMPLOYEE_EXCEL_FAILED,
      message: error?.message,
    });

    toast.error("Excel Upload Failed");
  } finally {
    store.dispatch(onLoaderTrigger(false));
  }
}

export function* uploadEmployeeExcelSaga() {
  yield takeEvery(
    UPLOAD_EMPLOYEE_EXCEL.UPLOAD_EMPLOYEE_EXCEL_REQUESTED,
    fetchUploadEmployeeExcel,
  );
}

// Approve Employee

function* fetchApproveEmployee(action) {
  store.dispatch(onLoaderTrigger(true));

  const payload = action.payload || {};

  const response = yield call(approveEmployeeService, {
    companyId: payload.companyId,
    employeeId: payload.employeeId,
  });

  if (response?.success) {
    yield put({
      type: APPROVE_EMPLOYEE.APPROVE_EMPLOYEE_SUCCESS,
    });

    toast.success(response.message);

    yield put({
      type: GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_REQUESTED,
      payload: {
        companyId: payload.companyId,
        search: payload.search,
        page: payload.page,
        pageSize: payload.pageSize,
        status: "",
      },
    });
  } else {
    yield put({
      type: APPROVE_EMPLOYEE.APPROVE_EMPLOYEE_FAILED,
    });

    toast.error(response.message);
  }

  store.dispatch(onLoaderTrigger(false));
}

export function* approveEmployeeSaga() {
  yield takeEvery(
    APPROVE_EMPLOYEE.APPROVE_EMPLOYEE_REQUESTED,
    fetchApproveEmployee,
  );
}
function* fetchRejectEmployee(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};

  try {
    const response = yield call(rejectEmployeeService, {
      companyId: payload.companyId,
      employeeId: payload.employeeId,
    });

    if (response?.success) {
      yield put({ type: REJECT_EMPLOYEE.REJECT_EMPLOYEE_SUCCESS });
      toast.success(response?.message || "Employee rejected");

      yield put({
        type: GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_REQUESTED,
        payload: {
          companyId: payload.companyId,
          search: payload.search,
          page: payload.page,
          pageSize: payload.pageSize,
          status: "",
        },
      });
    } else {
      yield put({ type: REJECT_EMPLOYEE.REJECT_EMPLOYEE_FAILED });
      toast.error(response?.message || "Reject Employee Failed");
    }
  } catch (error) {
    yield put({
      type: REJECT_EMPLOYEE.REJECT_EMPLOYEE_FAILED,
      message: error?.message,
    });
    toast.error(
      error?.response?.data?.message ||
        error?.message ||
        "Reject Employee Failed",
    );
  } finally {
    store.dispatch(onLoaderTrigger(false));
  }
}

export function* rejectEmployeeSaga() {
  yield takeEvery(
    REJECT_EMPLOYEE.REJECT_EMPLOYEE_REQUESTED,
    fetchRejectEmployee,
  );
}
